import { put, take } from 'redux-saga/effects';

import { DELETE_NOTETEXT } from './actions';
import { UPDATE_HIGHLIGHT } from 'Pipelines/Highlight/actions';


function* deleteNote() {
  while (true) {
    const { data:selectedHighlight } = yield take(DELETE_NOTETEXT);
    const newSelectedHighlight = { ...selectedHighlight, noteText: '' };

    yield put({
      type: UPDATE_HIGHLIGHT,
      data: {
        selectedHighlight: newSelectedHighlight
      }
    });
  }
}


export default deleteNote;
